import React, {useState, useEffect} from "react";

import {HeaderSection} from "../components/Header.jsx";
import {BackofficeTools} from "../components/BackofficeTools.jsx";
import {FeatureSection} from "../components/Features.jsx";
import {BackOfficeSection} from "../components/BackOffice.jsx";
import {ContactSection} from "../components/ContactSection.jsx";
import {FooterSection} from "../components/Footer.jsx";
import {Partner} from "../components/Partner.jsx";
import {Navbar} from "../components/NavBar";
import {ComingSoon} from "../components/ComingSoon";

const Homepage = () => {
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const isVisible = (elementOffset) => {
        return scrollY > elementOffset - window.innerHeight + 100;
    };

    return (

        <div className="min-h-screen bg-black text-gray-100">
            <Navbar/>
            <HeaderSection/>
            <BackofficeTools/>
            <Partner/>
            <FeatureSection/>
            <BackOfficeSection/>
            <ContactSection/>
            <ComingSoon/>
            <FooterSection/>
        </div>
    );
};

export default Homepage;
